import { Component } from '@angular/core';
import { ProductPromotionComponent } from '../product-promotion/product-promotion.component';

@Component({
  selector: 'app-promotion-section',
  standalone: true,
  imports: [ProductPromotionComponent],
  templateUrl: './promotion-section.component.html',
  styleUrl: './promotion-section.component.scss'
})
export class PromotionSectionComponent {
  promotions = [
    {
      imageUrl: 'img/featur-1.jpg',
      name: 'Apples',
      promotion: '20% OFF'
    }, {
      imageUrl: 'img/featur-2.jpg',
      name: 'Fruits',
      promotion: 'Free delivery'
    }, {
      imageUrl: 'img/featur-3.jpg',
      name: 'Vegitable',
      promotion: 'Discount 30$ '
    }];
}
